import BaseAPI from "./BaseAPI";

export default class CheckScheduleAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, "check-schedules", "check-schedule");
    }

    async Create(data, idempotencyKey = null) {
        const options = idempotencyKey ? { headers: { "Idempotency-Key": idempotencyKey } } : {};
        const result = await this._request("post", this._url(), data, options);
        this._emit("create", result.id);
        return result;
    }

    async ListWithFormID(formID) {
        return this._request("get", this._url(`?form_id=${formID}`));
    }

    async Occurrences(locationID = "", referenceAt = null) {
        const params = new URLSearchParams();
        if (locationID) params.set("location_id", locationID);
        if (referenceAt) params.set("reference_at", String(referenceAt));
        return this._request("get", this._url(`/occurrences?${params}`));
    }

    async HistoryPage(params = {}, { signal } = {}) {
        const query = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
            if (value !== undefined && value !== null) query.set(key, String(value));
        }
        const response = await this._request("get", this._url(`/history?${query}`), null, {
            rawData: true,
            signal
        });
        if (!Array.isArray(response?.data))
            throw new Error("Scheduled check history is unavailable");
        return { data: response.data, next_page_token: response.next_page_token || "" };
    }

    async History(params = {}, options = {}) {
        const rows = [];
        const finalBefore = Number(params.before);
        for (let after = Number(params.after); after < finalBefore;) {
            const before = Math.min(finalBefore, after + 90 * 86400000);
            let token = "";
            do {
                const page = await this.HistoryPage(
                    { ...params, after, before, limit: 500, page_token: token },
                    options
                );
                rows.push(...page.data);
                token = page.next_page_token;
            } while (token);
            after = before;
        }
        return rows;
    }
}
